import { z } from 'zod'

import ZBaseAction from './base'

const ZResendQuestionAction = ZBaseAction.extend({
  resendQuestion: z.object({}),
})

export default ZResendQuestionAction
